import { VariantProps } from 'class-variance-authority'
import { Link, LinkProps } from 'react-router-dom'
import { buttonVariants } from './button'
import Card from 'app/frontend/base/components/Card'

type Props = LinkProps & Omit<VariantProps<typeof buttonVariants>, 'variant'>

const LinkButton = ({ children, size, ...props }: Props) => {
  return (
    <Link {...props}>
      <Card className={buttonVariants({ variant: 'outline', size })}>
        {children}
      </Card>
    </Link>
  )
}

export default LinkButton
